<template>
  <div class="table__body">
    <div v-if="!isLoading" class="table__nav">
      <ul class="table__nav-list">
        <li v-for="(item, idx) in getHeaderTable" :key="item + idx" class="table__col">
          <p class="table__col-title">{{ tableHeader[item] }}</p>
        </li>
      </ul>
    </div>
    <div class="table__content">
      <template v-if="!isLoading">
        <TableRow
          v-for="(item, idx) in data"
          :key="'user' + idx"
          :data="item"
          :row="getHeaderTable"
        ></TableRow>
      </template>
      <template v-else>
        <SkeletRow v-for="i in 5" :key="i"></SkeletRow>
      </template>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import TableRow from './TableRow';
import SkeletRow from './SkeletRow';

export default {
  components: {
    TableRow,
    SkeletRow
  },
  props: ['tableData', 'isLoading'],
  data() {
    return {
      data: '',
      tableHeader: {
        fullName: 'Имя',
        city: 'Город',
        email: 'Email',
        groupName: 'Группа',
        points: 'Баллы'
      }
    };
  },
  computed: {
    getHeaderTable() {
      return Object.keys(this.tableHeader);
    }
  },
  watch: {
    tableData(val) {
      this.data = _.cloneDeep(val);
    }
  },
  mounted() {
    this.data = _.cloneDeep(this.tableData);
  }
};
</script>
